import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import ProductCard from './prod-card';
import { tokens } from '../../theme';
import { useTheme } from '@emotion/react';


const ProdModal = (props) => {
    const { handleClose,
        open,
        selectedProd
    } = props

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1200,
        bgcolor: colors.pink[700],
        borderRadius: '12px',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                {
                    selectedProd && selectedProd.length > 0 &&
                    selectedProd.map((prod, i) => {
                        return (
                            <ProductCard product={prod} key={i} handleClose={handleClose}/>
                        )
                    })
                }
                </Box>
            </Modal>
        </div>
    );
}

export default ProdModal